import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import './SidePanelExcilyensCertificationsEntry.scss';
import { certificationActions } from 'app/redux/slices/certifications.slice';
import {
    selectCertificationsFilter,
    selectFilterableCertifications
} from 'app/redux/selectors/Certification/certifications.selector';

export default function SidePanelExcilyensCertificationsEntry() {

    const dispatch = useDispatch();

    const certifications = useSelector(selectFilterableCertifications);
    const certificationsFilter = useSelector(selectCertificationsFilter);

    const options = certifications.map((certification) => ({
        value: certification.id,
        label: certification.name
    }));

    const selectedOptions = options.filter((option) => certificationsFilter.includes(option.value));

    const handleChangeMulti = (value) => {
        dispatch(certificationActions.setCertificationsFilter(value ? value.map((option) => option.value) : []));
    };

    return (
        <div className="expert-certification-filter" data-testid="side-panel-excilyens-certifications-entry">
            <Typography className="sub-title">Certifications</Typography>
            <div data-testid="side-panel-excilyens-certifications-entry-select">
                <Select
                    name="side-panel-excilyens-certifications-entry-select"
                    classNamePrefix="certification-select"
                    placeholder="Certifications"
                    noOptionsMessage={() => 'Aucune certification'}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: '#3f51b5'
                        }
                    })}
                    options={options}
                    value={selectedOptions}
                    onChange={handleChangeMulti}
                    isMulti
                />
            </div>
        </div>
    );
}
